<header class="d-flex align-items-center primary-header">
   <nav class="container d-flex align-items-center gap-2 px-3 px-md-4 px-lg-5">
      <button class="menu-btn border-0 bg-transparent text-white d-block d-xl-none" (click)="openSidebar()" aria-label="Open navigation">
         <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 5h16M4 12h16M4 19h16"/>
         </svg>
      </button>

      <a routerLink="/" class="d-block d-xl-none">
         <img src="/assets/images/header/musaffa-logo-white.webp" width="118" height="24" alt="Musaffa Logo" class="header-logo img-fluid" />
      </a>

      <button class="d-none d-lg-flex align-items-center gap-2 fw-normal rounded-pill py-2 ps-3 pe-4 bg-white search-btn" (click)="openSearch()">
         <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
            <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m15 15 1.5 1.5m.433 2.525a1.48 1.48 0 1 1 2.092-2.092l2.042 2.042a1.48 1.48 0 1 1-2.092 2.092zM16.5 9.5a7 7 0 1 0-14 0 7 7 0 0 0 14 0"/>
         </svg>
         <span class="d-none d-lg-flex d-xxl-none">Search</span>
         <span class="d-none d-xxl-flex">Search Stocks & ETFs</span>
      </button>

      @for (item of navItems; track item.label) {
         @if (item.children) {
            <div ngbDropdown class="d-none d-xl-inline-block" routerLinkActive="about-active" [routerLinkActiveOptions]="{ exact: false }">
               <button class="border-0 d-block lh-sm header-link" [id]="item.label + 'Dropdown'" ngbDropdownToggle>
                  {{ item.label }}
               </button>
               <div ngbDropdownMenu [attr.aria-labelledby]="item.label + 'Dropdown'" class="border border-light shadow header-dropdownmenu p-2">
                  <div class="dropdown-links-grid">
                     @for (child of item.children; track child.label) {
                        @if (!child.isExternal) {
                           <a [routerLink]="child.route" routerLinkActive="active-link" class="d-block text-decoration-none" ngbDropdownItem>
                              {{ child.label }}
                           </a>
                        } @else {
                           <a [href]="child.route" target="_blank" rel="noopener noreferrer" class="d-flex align-items-start gap-1 text-decoration-none" ngbDropdownItem>
                              {{ child.label }}
                              @if (!child.hideExternalIcon) {
                                 <svg class="d-block flex-shrink-0" xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24">
                                    <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M11.1 3c-3.65.007-5.56.096-6.782 1.318C3 5.636 3 7.757 3 12c0 4.242 0 6.364 1.318 7.682S7.757 21 12 21s6.363 0 7.68-1.318c1.222-1.221 1.312-3.133 1.318-6.782m-.442-9.404-9.507 9.563m9.507-9.563c-.494-.494-3.822-.448-4.525-.438m4.525.438c.494.495.448 3.827.438 4.531"/>
                                 </svg>
                              }
                           </a>
                        }
                     }
                  </div>
               </div>
            </div>
         } @else if (item.isExternal) {
            <a [href]="item.route" target="_blank" rel="noopener noreferrer" class="d-none d-xl-flex gap-1 header-link text-decoration-none">
               {{ item.label }}
               @if (!item.hideExternalIcon) {
                  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24">
                     <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M11.1 3c-3.65.007-5.56.096-6.782 1.318C3 5.636 3 7.757 3 12c0 4.242 0 6.364 1.318 7.682S7.757 21 12 21s6.363 0 7.68-1.318c1.222-1.221 1.312-3.133 1.318-6.782m-.442-9.404-9.507 9.563m9.507-9.563c-.494-.494-3.822-.448-4.525-.438m4.525.438c.494.495.448 3.827.438 4.531"/>
                  </svg>
               }
            </a>
         } @else {
            <a [routerLink]="item.route" routerLinkActive="active-link" class="d-none d-xl-block header-link text-decoration-none">
               {{ item.label }}
            </a>
         }
      }

      <div class="d-flex align-items-center gap-2 ms-auto">

         @if (isLoggedIn() && userNewRole() && ['free', 'starter', 'premium'].includes(userNewRole()!)) {
            <a routerLink="/pricing" class="text-decoration-none text-nowrap d-none d-xl-flex align-items-center gap-2 button upgrade-btn">
               <img src="/assets/icons/premium-gold.svg" alt="Icon" width="14" height="14" class="img-fluid">
               Upgrade Now
            </a>
         }

         <button class="border-0 d-lg-none bg-transparent" (click)="openSearch()">
            <img src="/assets/icons/search-blue.svg" alt="Search Icon" width="16" height="16">
         </button>

         @if (isLoggedIn()) {
            <app-header-user-notifications></app-header-user-notifications>
         }

         <app-user-dropdown 
            [user]="user()"
            [trialNotClaimed]="trialNotClaimed()"
            [userLoading]="userLoading()"
            [userError]="userError()"
            [showQuestionnaireReward]="showQuestionnaireReward()"
            [userNewRole]="userNewRole()">
         </app-user-dropdown>

         @if (!isLoggedIn()) {
            <a (click)="onSignUpClick()" routerLink="/authentication/register" class="d-block text-decoration-none button green-btn">
               {{ isInvestingPlatform() ? "Open Account / Login" : "Free Sign Up / Login" }}
            </a>
         }
         
      </div>
   </nav>
</header>
